<div class="outlet" [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet" (activate)="onActivate($event)" ></router-outlet>
  </div>
  
